<template>
    <div class="info-game" :style="bgClock">
        <!-- <img v-if="typeInfo == 'score'" src="../../assets/score.png" alt="" class="info-icon"> -->
        <!-- <img v-if="typeInfo == 'clock'" src="../../assets/clock.png" alt="" class="info-icon"> -->
        <Coin v-if="typeInfo == 'score'" class="info-icon" />
        <HeaderClock class="info-icon" v-if="typeInfo == 'clock'" />
        <span class="info">
            <loader-clock v-if="loader"></loader-clock>
            {{ dataInfo }}
        </span>
        <!-- <clock v-if="typeInfo == 'clock'"></clock> -->
    </div>
</template>
<script>
import moment from 'moment'
moment.locale('pt-br');
import Clock from '../Clock/Clock.vue'
import Coin from '../Shared/CustomIcons/Header/Coin.vue'
import LoaderClock from '../Loaders/LoaderClock'
import HeaderClock from "../Shared/CustomIcons/Header/Clock.vue"
export default {
    components:{
        Clock,
        Coin,
        LoaderClock,
        HeaderClock
    },
    props: {
        typeInfo: {
            type : String,
            required : true
        },
        dataInfo : {
            
        },
        bgColor : {
            type : String,
            required : true
        },
        loader : {
            type : Boolean
        }
    },
    computed: {
        bgClock(){
            return {
                'background-color' : this.bgColor
            }
        }
    },
    
}
</script>
<style lang="scss" scoped>
    .info-game{

        
        height: 25px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        position: relative;
        border-radius: 32px;
        width: 80px;
        margin: 0 10px 0 20px;
        padding-right: 2%;

        .info-icon{

            width: 32px;
            position: absolute;
            left: -10px;
        }

        .info{
            color: #000;
            margin-right: 10px;
            margin-bottom: 2px;
            font-weight: 900;
            font-size: 15px;
        }
    }

    @media only screen and (min-width : 750px) {
        .info-game{

            height: 30px;
            width: 80px;

            .timer{
                font-size: 16px;
            }

            .info-icon{

                height: 40px;
            }

            .info{

                font-size: 1em;
                margin-left: 28px;
                margin-right: 5px;
            }
        }
    }
</style>


